import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1276ac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "tir-pm-svg__content"
}

import { ref, onMounted, watch, computed, CSSProperties } from "vue";

// #region defineProps

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-svg',
  props: {
  /**Ссылка на svg */
  url: { type: String },
  /**Цвет */
  color: { type: String },
  /**Цвет */
  backgroundColor: { type: String },
  /**Включить заливку */
  isFill: { type: Boolean, default: true },
},
  setup(__props) {

const props = __props;


// #endregion defineProps

// #region refs
/**Контент svg иконки */
const svgContent = ref<string | null>(null);
// #endregion refs

// #region computed
/**С фоном */
const withBg = computed(
  () => props.isFill && (props.backgroundColor || props.color)
);

const style = computed<CSSProperties>(() => {
  const obj: CSSProperties = {};
  if (props.color) {
    obj["--tir-pm-svg__bg-color"] = props.isFill
      ? props.backgroundColor ?? props.color
      : undefined;
    obj["--tir-pm-svg__bg-opacity"] = props.isFill
      ? props.backgroundColor
        ? "1"
        : "0.10"
      : "0";
    obj["--tir-pm-svg__icon-color"] = props.color;
  }
  return obj;
});
// #endregion computed

// #region watch
watch(() => props.url, loadSvg);
// #endregion watch

// #region Хуки жизненного цикла
onMounted(() => {
  loadSvg();
});
// #endregion Хуки жизненного цикла

// #region Функции
async function loadSvg() {
  if (props.url)
    try {
      // Проверяем наличие SVG в sessionStorage
      const cachedSvg = sessionStorage.getItem(props.url);
      if (cachedSvg) {
        svgContent.value = cachedSvg;
        return;
      }

      // Загружаем SVG с сервера
      const response = await fetch(props.url);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "image/svg+xml");
      const svg = doc.querySelector("svg");
      if (!svg) {
        throw new Error("Invalid SVG format");
      }

      // Сохраняем в sessionStorage и обновляем значение
      sessionStorage.setItem(props.url, text);
      svgContent.value = text;
    } catch (error) {
      console.error("Error fetching SVG:", error);
    }
}
// #endregion Функции

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['tir-pm-svg', { 'with-bg': withBg.value }]),
    style: _normalizeStyle(style.value)
  }, [
    (__props.url)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (svgContent.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "tir-pm-svg__content",
                innerHTML: svgContent.value
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]))
  ], 6))
}
}

})